import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  role: string;
  content: string;
  image?: string;
}
export function TestimonialCard({
  name,
  role,
  content,
  image
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 h-full flex flex-col" data-id="element-301">
      <div className="flex gap-1 mb-4" data-id="element-302">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-blue-600 text-blue-600" data-id="element-303" />)}
      </div>
      <p className="text-slate-700 italic mb-6 flex-grow leading-relaxed" data-id="element-304">
        "{content}"
      </p>
      <div className="flex items-center gap-3 mt-auto" data-id="element-305">
        <div className="w-10 h-10 rounded-full bg-slate-200 flex items-center justify-center overflow-hidden" data-id="element-306">
          {image ? <img src={image} alt={name} className="w-full h-full object-cover" data-id="element-307" /> : <span className="text-slate-500 font-bold text-lg" data-id="element-308">
              {name.charAt(0)}
            </span>}
        </div>
        <div data-id="element-309">
          <h4 className="font-bold text-slate-900 text-sm" data-id="element-310">{name}</h4>
          <p className="text-slate-500 text-xs" data-id="element-311">{role}</p>
        </div>
      </div>
    </div>;
}